import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Printable_DiseaseProfile } from '@app/dp-frontend';
import { QScrollWrapper } from '@app/hcs-frontend';
class PgComponent extends React.Component {
    render() {
        return _jsx(QScrollWrapper, { className: 'match_parent', children: _jsx(Printable_DiseaseProfile, { diseaseProfileId: '74a1df9c7a09374a99925d71e537512f' }) });
    }
}
export const PgDev_PrintableDP = { name: 'Printable DP', key: 'printable-dp', renderer: PgComponent };
